var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3816 23.6526C20.1602 18.6116 13.6429 14.863 12.0465 18.7072C12.0273 18.7509 11.8743 19.1663 11.7567 19.4231L3.59648 42.3496C3.129 43.6666 3.26841 44.6474 3.87538 45.1474C4.37559 45.7513 5.35702 45.8933 6.67467 45.4261L29.6134 37.2703C29.8705 37.1528 30.286 36.9998 30.3297 36.9806C34.1761 35.385 30.4254 28.8712 25.3816 23.6526Z",
    stroke: "url(#paint0_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9987 29.7398C24.5711 32.6551 26.605 35.789 27.1081 38.1606L22.8981 39.658C21.7827 37.2208 19.6368 34.3792 17.1873 31.8409C14.6476 29.3928 11.8046 27.248 9.36609 26.1332L10.8642 21.9254C13.3409 22.45 16.6487 24.6413 19.6695 27.3709",
    stroke: "url(#paint1_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5057 36.5208C14.1487 38.223 15.6549 40.0619 16.8058 41.8241L12.0109 43.5264C11.106 42.3433 10.0808 41.1575 8.99282 40.0318C7.86647 38.9443 6.6801 37.9197 5.49634 37.0154L7.19947 32.2229C8.96272 33.3732 10.8025 34.8787 12.5057 36.5208Z",
    stroke: "url(#paint2_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5281 15.6955L32.4778 12.149C32.8523 11.7747 33.4646 11.7747 33.8392 12.149L36.8462 15.1519C37.2208 15.5261 37.2208 16.1382 36.8462 16.5125L26.6276 24.9989M23.9868 22.3623L27.3957 18.2639",
    stroke: "url(#paint3_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9828 19.969C24.1539 14.8761 23.1534 9.99892 22.4125 6.98796C21.5104 3.3158 16.4038 4.18747 17.4481 8.07271C18.3366 11.387 18.7248 14.0017 18.1014 18.2013",
    stroke: "url(#paint4_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1176 28.1222C34.3088 25.3216 39.0656 26.5539 42.0071 27.4364C45.6321 28.5239 44.503 33.5758 40.673 32.3381C37.4991 31.3108 34.9595 30.7916 30.9383 31.1387",
    stroke: "url(#paint5_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7825 2.1491L39.1974 4.20648C39.1319 4.4305 39.1346 4.49885 38.9132 4.6218L36.9503 5.70383C36.5704 5.9142 36.5758 6.01527 36.9394 6.25574L38.73 7.52074C38.9213 7.65734 38.9952 7.85415 39.0417 8.10547L39.4217 10.1629C39.4873 10.5945 39.5884 10.6219 39.9356 10.3596L41.5786 9.09457C41.748 8.96339 42.0516 8.8814 42.2648 8.9115L44.3177 9.1847C44.7524 9.2393 44.8235 9.16553 44.6677 8.75845L43.9651 6.78577C43.8804 6.54539 43.8476 6.34045 43.9459 6.12456L44.8618 4.13272C45.0558 3.74471 45.0121 3.65458 44.5748 3.6628L42.3358 3.70647C42.0816 3.70927 42.0488 3.64915 41.882 3.48787L40.3456 1.99885C40.0339 1.69826 39.9028 1.73379 39.7825 2.1491Z",
    stroke: "url(#paint6_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8572 3.70627L29.1234 2.12702C28.8145 1.94938 28.358 2.03138 28.2349 2.3675L26.7451 6.38934C26.6193 6.72546 26.6739 7.09972 26.9828 7.27736L28.4645 8.13529C28.7763 8.31293 29.1261 8.17082 29.353 7.89481L32.095 4.5943C32.3246 4.3183 32.1688 3.88391 31.8572 3.70627Z",
    stroke: "url(#paint7_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4667 14.1576H46.6057C47.0758 14.1576 47.5378 14.5483 47.4586 15.0101L46.5127 20.5538C46.4334 21.0155 46.1272 21.4062 45.6597 21.4062H43.4154C42.9452 21.4062 42.6418 21.0155 42.5624 20.5538L41.6139 15.0101C41.5346 14.5483 41.9994 14.1576 42.4667 14.1576Z",
    stroke: "url(#paint8_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6605 15.5536L5.65719 14.4826C6.11102 14.3596 6.65779 14.6191 6.70154 15.0837L7.22363 20.6848C7.26738 21.152 7.07328 21.6084 6.61955 21.7285L4.45165 22.3105C3.99781 22.4308 3.6042 22.133 3.40739 21.7067L1.05633 16.5973C0.859517 16.1711 1.20667 15.6739 1.6605 15.5536Z",
    stroke: "url(#paint9_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.294 44.8598L32.5986 47.5538C32.2924 47.8598 31.7374 47.9063 31.4887 47.5538L28.4925 43.327C28.2409 42.9745 28.1863 42.521 28.4925 42.215L29.9523 40.7559C30.2585 40.4498 30.7123 40.5045 31.065 40.7559L35.294 43.7504C35.6466 43.9991 35.6002 44.5538 35.294 44.8598Z",
    stroke: "url(#paint10_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99821 2.26436L10.6351 4.49659C10.7063 4.73977 10.7035 4.81354 10.9441 4.94743L13.0737 6.1223C13.4865 6.34912 13.4809 6.45842 13.0873 6.72068L11.1436 8.09498C10.9332 8.24252 10.8539 8.45569 10.8019 8.72888L10.3918 10.9612C10.3181 11.4284 10.2087 11.4584 9.83141 11.1743L8.0518 9.79998C7.86584 9.65786 7.53785 9.57045 7.30551 9.60046L5.0775 9.89834C4.6073 9.95836 4.52802 9.87646 4.69753 9.43656L5.46018 7.29718C5.55321 7.03492 5.58864 6.81081 5.48205 6.57866L4.48697 4.41739C4.27371 3.99395 4.32298 3.8955 4.79588 3.90644L7.22894 3.9529C7.50503 3.95842 7.53785 3.89279 7.72101 3.71524L9.38852 2.10046C9.72754 1.77257 9.86965 1.81081 9.99821 2.26436Z",
    stroke: "url(#paint11_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4396 35.3163L41.245 37.3109C41.1137 37.5294 41.0974 37.6005 40.8294 37.6661L38.4647 38.2508C38.0054 38.3655 37.9837 38.472 38.298 38.8273L39.8207 40.6607C39.9847 40.8574 40.0066 41.0841 39.9847 41.3601L39.8042 43.6279C39.7523 44.0978 39.8508 44.1552 40.291 43.9777L42.3685 43.1115C42.5872 43.0213 42.9262 43.0213 43.1422 43.1115L45.2226 43.9777C45.6599 44.1552 45.7583 44.0978 45.7092 43.6279L45.526 41.3601C45.5041 41.0841 45.526 40.8574 45.6901 40.6607L47.2154 38.8273C47.5298 38.472 47.5052 38.3655 47.046 38.2508L44.6813 37.6661C44.4133 37.6005 44.397 37.5294 44.2657 37.3109L43.0711 35.3163C42.8306 34.912 42.683 34.912 42.4396 35.3163Z",
    stroke: "url(#paint12_linear_144_281)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_144_281",
    x1: 17.6155,
    y1: 45.7037,
    x2: 17.6155,
    y2: 17.1246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_144_281",
    x1: 18.2371,
    y1: 39.658,
    x2: 18.2371,
    y2: 21.9254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_144_281",
    x1: 11.1511,
    y1: 43.5264,
    x2: 11.1511,
    y2: 32.2229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_144_281",
    x1: 30.557,
    y1: 24.9989,
    x2: 30.557,
    y2: 11.8683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_144_281",
    x1: 20.2386,
    y1: 19.969,
    x2: 20.2386,
    y2: 4.64923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_144_281",
    x1: 36.6642,
    y1: 32.532,
    x2: 36.6642,
    y2: 26.3907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_144_281",
    x1: 40.8188,
    y1: 10.5283,
    x2: 40.8188,
    y2: 1.80098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_144_281",
    x1: 29.4434,
    y1: 8.21387,
    x2: 29.4434,
    y2: 2.03565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_144_281",
    x1: 44.5362,
    y1: 21.4062,
    x2: 44.5362,
    y2: 14.1576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_144_281",
    x1: 4.11482,
    y1: 22.3374,
    x2: 4.11482,
    y2: 14.4521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_144_281",
    x1: 31.9121,
    y1: 47.801,
    x2: 31.9121,
    y2: 40.5464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_144_281",
    x1: 8.87456,
    y1: 11.3569,
    x2: 8.87456,
    y2: 1.88445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_144_281",
    x1: 42.7562,
    y1: 44.0703,
    x2: 42.7562,
    y2: 35.0131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0169F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/Party.c57a3243edf74712b225572dc8f8d72b.svg";
export { ForwardRef as ReactComponent };